import { ListItem, ListItemText } from '@mui/material';
import List from '@mui/material/List';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import { BatchClientInsurerType } from '../../types';
import { cleanTypeNameGraphql } from '../../utils/graphql-utils';
import { ClientInsurerBatchCard } from './batch-client-insurer-card';

export interface ClientInsurerBatchListProps {
  clientInsurers: BatchClientInsurerType[] | [];
  onRemove: (id: number) => void;
}

export const CLIENT_INSURER_BATCH_LIST_CONTAINER =
  'client-insurer-batch-list-container';

export const ClientInsurerBatchList = ({
  clientInsurers,
  onRemove,
}: ClientInsurerBatchListProps): JSX.Element => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        overflowY: 'auto',
        padding: '1em',
        boxShadow: 'none',
      }}
      data-testid={CLIENT_INSURER_BATCH_LIST_CONTAINER}
    >
      <List>
        <ListItem alignItems="flex-start">
          <ListItemText primary="Selected client insurers" />
        </ListItem>
        {cleanTypeNameGraphql(clientInsurers).map(ci => (
          <ClientInsurerBatchCard
            client={ci.client}
            insurer={ci.insurer}
            id={ci.id}
            onRemove={onRemove}
            key={ci.id}
          />
        ))}
      </List>
    </Paper>
  );
};
